import { useContext } from "react";
import { StudentAuthContext } from "./StudentAuthContext";

export const useStudentAuthContext = () => {
    const context = useContext(StudentAuthContext);
    if(!context){
        throw Error('useStudentAuthContext must be used inside student pages');
    }
    return context;
}